module.exports = __webpack_public_path__ + "static/img/2.9fadf40a.png";